import './mute_toggle.scss';
import { h } from 'preact';
import { BaseAnnotation } from '../base_annotation';
import { IoIosVolumeOff } from 'react-icons/io';
import { PLAYER_EVENT, PLAYER_CONTROL_EVENT } from 'constants/events';
import { accessible } from 'utilities/accessibility';
import { InvisibleAnnotation } from 'rendering/components/invisible_annotation';


export class MuteToggle extends BaseAnnotation {
    constructor(...args) {
        super(...args);
        this.eventBus.on(PLAYER_EVENT.VOLUME_CHANGE, this.onVolumeChange.bind(this));
    }

    onClick = () => {
        this.setState({
            muted: false
        });

        this.eventBus.emit(PLAYER_CONTROL_EVENT.MUTE, false);
    }

    onVolumeChange(event, adapter) {
        this.setState({
            muted: adapter.volume === 0 ? true : false
        });
    }

    render() {
        if (this.state.muted) {
            return (
                <div className="mute-toggle" style={ this.styles } role="button" aria-label="Unmute video" { ...accessible(this.onClick) }>
                    <IoIosVolumeOff className="icon" onClick={ this.onClick } />
                </div>
            );
        }

        return <InvisibleAnnotation { ...this.dataAttrs } />;
    }

    get styles() {
        return {
            ...super.styles,
            padding: '12px'
        }
    }

    get defaultState() {
        return {
            muted: this.props.muted || false
        }
    }
}